var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOptimalLevelsBlack40X40(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#272724",
    d: "M39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5C30.7696 0.5 39.5 9.23045 39.5 20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#272724",
    d: "M19.7563 33.5V6.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#272724",
    d: "M6.25659 20H33.2566"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#272724",
    d: "M23.3088 16.4476L29.3023 10.4541"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#272724",
    d: "M16.2039 23.5527L10.2104 29.5462"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#272724",
    d: "M16.2039 16.4476L10.2104 10.4541"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#272724",
    d: "M23.3088 23.5527L29.3023 29.5462"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimalLevelsBlack40X40);
export default __webpack_public_path__ + "static/media/Optimal-levels-black-40x40.b5f84282abc8c9870b9b17d2d31765d3.svg";
export { ForwardRef as ReactComponent };